const featureFlags = {
  // TODO: remove this feature flag as it's not used anymore, but will need to update the featureFlagReducer test so it's using mocks
  hideArticleBodyHyperlinks: 'hideArticleBodyHyperlinks',
};

// Module Exports
export { featureFlags };
